var _g, _g2, _g3, _g4, _g5, _g6, _g7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLandingGradiant(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2665,
    height: 2030,
    viewBox: "0 0 2665 2030",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_460_690)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 687,
    cy: 998,
    rx: 253,
    ry: 217,
    fill: "#0ABDBD",
    fillOpacity: 0.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_460_690)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 951.411,
    cy: 599.627,
    rx: 253,
    ry: 217,
    transform: "rotate(28.1187 951.411 599.627)",
    fill: "#AEFFFF",
    fillOpacity: 0.5
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_460_690)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1883.41,
    cy: 666.627,
    rx: 253,
    ry: 217,
    transform: "rotate(28.1187 1883.41 666.627)",
    fill: "#AEFFFF",
    fillOpacity: 0.5
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_460_690)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2047.34,
    cy: 993.721,
    rx: 253,
    ry: 217,
    transform: "rotate(-32.961 2047.34 993.721)",
    fill: "#0ABDBD",
    fillOpacity: 0.5
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_460_690)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 745,
    cy: 1439,
    rx: 371,
    ry: 217,
    fill: "#4D869C"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_460_690)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1977,
    cy: 1304.5,
    rx: 252,
    ry: 205.5,
    fill: "#4D869C"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_460_690)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1412.94,
    cy: 729.161,
    rx: 377.629,
    ry: 177.809,
    transform: "rotate(1.42757 1412.94 729.161)",
    fill: "#AEFFFF",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_460_690",
    x: 60,
    y: 407,
    width: 1254,
    height: 1182,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 187,
    result: "effect1_foregroundBlur_460_690"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_460_690",
    x: 331.891,
    y: 0.102905,
    width: 1239.04,
    height: 1199.05,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 187,
    result: "effect1_foregroundBlur_460_690"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_460_690",
    x: 1263.89,
    y: 67.1029,
    width: 1239.04,
    height: 1199.05,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 187,
    result: "effect1_foregroundBlur_460_690"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_460_690",
    x: 1430.4,
    y: 391.46,
    width: 1233.89,
    height: 1204.52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 187,
    result: "effect1_foregroundBlur_460_690"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_460_690",
    x: 0,
    y: 848,
    width: 1490,
    height: 1182,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 187,
    result: "effect1_foregroundBlur_460_690"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_460_690",
    x: 1351,
    y: 725,
    width: 1252,
    height: 1159,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 187,
    result: "effect1_foregroundBlur_460_690"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_460_690",
    x: 661.403,
    y: 177.155,
    width: 1503.08,
    height: 1104.01,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 187,
    result: "effect1_foregroundBlur_460_690"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingGradiant);
export default __webpack_public_path__ + "static/media/landing_gradiant.3fafa1ecebd4dfac370d40c239699bcc.svg";
export { ForwardRef as ReactComponent };